module.exports = "<button type=\"button\" class=\"btn-notifications\" mat-icon-button (click)=\"toggleNotificationsMenu()\">\n  <i *ngIf=\"!notifications.length\" class=\"fa fa-bell-o\"></i>\n  <i *ngIf=\"notifications.length\" class=\"fa fa-bell\"></i>\n  <span *ngIf=\"notifications.length\" class=\"notifications-count\">{{ notifications.length }}</span>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/core/top-navbar/notifications-menu/button/notifications-menu-button.component.html
// module id = ./src/app/system/core/top-navbar/notifications-menu/button/notifications-menu-button.component.html
// module chunks = main